import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from './../../constants/defaultValues';
import {
  LOGIN_USER,
  LOGIN_USER_GOOGLE
} from '../actions';

import {
  loginUserSuccess,
  loginUserError
} from './actions';

import { setCurrentUser } from '../../helpers/Utils';

const urlRedirectHome = '/app/home'
function MaysPrimera(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

export function* watchLoginUserGoogle() {
  yield takeEvery(LOGIN_USER_GOOGLE, loginGoogleWithEmailPassword);
}

const loginWithEmailPasswordAsync = async (email, password) =>
  await authFB
    .signInWithEmailAndPassword(email, password)
    .then((user) => user)
    .catch((error) => error);

const loginUserCreateCollectionAsync = async (email, name, uid) => {
  /* const userRaw = await database.collection('user').doc(uid).get();
  return userRaw.data();  */
  const dataInsert = { email: email, name: name, uid: uid }

  const datos = await fetch(servicePath+'create/user', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dataInsert)
  })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      return data;
    })
    .catch(err => console.log(err));

  return datos;

};

const loginUserCollectionAsync = async (email) => {

  const datos = await fetch(servicePath+'login/' + email, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {
      return data.data;
    })
    .catch(err => console.log(err));

  return datos;

};

function* loginWithEmailPassword({ payload }) {

  const { email, password } = payload.user;
  const { history } = payload;
  try {
    const loginUser = yield call(loginWithEmailPasswordAsync, email, password);

    var message = '';
    var code = '';
    switch (loginUser.code) {
      case 'auth/too-many-requests':
        code = 'Demasiadas Solicitudes'
        message = 'Demasiados intentos de inicio de sesión fallidos. Por favor, inténtelo de nuevo más tarde.'
        break;
      case 'auth/wrong-password':
        code = 'Contraseña Incorrecta'
        message = 'La contraseña no es válida o el usuario no tiene una contraseña.'
        break;
      case 'auth/invalid-email':
        code = 'Correo electrónico no válido'
        message = 'La dirección de correo electrónico está mal formateada.'
        break;
      case 'auth/user-not-found':
        code = 'Usuario no encontrado'
        message = 'No hay registro de usuario correspondiente a este identificador. El usuario puede haber sido eliminado.'
        break;
      default:
        code = loginUser.code
        message = loginUser.message
    }

    if (!loginUser.message) {

      const user = yield call(loginUserCollectionAsync, email);

      if (user !== null) {
        const item = { uid: loginUser.user.uid, ...user, title: user.name, role: 0 };
        setCurrentUser(item);
        yield put(loginUserSuccess(item));
        history.push(urlRedirectHome);
      } else {
        yield put(loginUserError({ code: 'Usuario no encontrado', message: 'Usuario no registrado en base de datos.' }));
      }
    } else {
      yield put(loginUserError({ code: code, message: message }));
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

function* loginGoogleWithEmailPassword({ payload }) {

  const { email, displayName, uid } = payload.user;
  const name = MaysPrimera(displayName.toLowerCase());
  const history = payload.history;

  const userExist = yield call(loginUserCollectionAsync, email);
  if (userExist !== null) {

    const item = { title: userExist.name, role: 1, ...userExist };
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
    history.push(urlRedirectHome);
  } else {

    const userCreate = yield call(loginUserCreateCollectionAsync, email, name, uid);
    if (userCreate.error === 0) {
      const user = yield call(loginUserCollectionAsync, email);

      const item = { title: user.name, role: 1, ...user };

      setCurrentUser(item);
      yield put(loginUserSuccess(item));
      history.push(urlRedirectHome);
    } else {
      console.log("error, google")
    }
  }
}


export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLoginUserGoogle)
  ]);
}
